export default "__VITE_PUBLIC_ASSET__93f11bb1__"